module.exports = __webpack_public_path__ + "h5/img/gouwu.b01c5906.png";